<template>
  <div class="modal-body">
    <div class="details-price px-0">
      <div class="list-detail">
        <p class="title mb-0">Account Provider</p>
        <p class="strong">{{ account_details.bank_name || 'NA' }}</p>
      </div>
    </div>

    <div class="details-account mb-0">
      <p class="mb-0" v-if="account_details.sort_code">
        SORT CODE: <span id="sortCode">{{ account_details.sort_code }}</span> &nbsp;
        <span @click.prevent="copyAccount('sortCode')">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.25 4.375V12.25H4.375V4.375H12.25ZM12.25 3.5H4.375C4.14294 3.5 3.92038 3.59219 3.75628 3.75628C3.59219 3.92038 3.5 4.14294 3.5 4.375V12.25C3.5 12.4821 3.59219 12.7046 3.75628 12.8687C3.92038 13.0328 4.14294 13.125 4.375 13.125H12.25C12.4821 13.125 12.7046 13.0328 12.8687 12.8687C13.0328 12.7046 13.125 12.4821 13.125 12.25V4.375C13.125 4.14294 13.0328 3.92038 12.8687 3.75628C12.7046 3.59219 12.4821 3.5 12.25 3.5V3.5Z"
              fill="#262424" />
            <path
              d="M1.75 7.875H0.875V1.75C0.875 1.51794 0.967187 1.29538 1.13128 1.13128C1.29538 0.967187 1.51794 0.875 1.75 0.875H7.875V1.75H1.75V7.875Z"
              fill="#262424" />
          </svg>
        </span>
      </p>

     <div class="copy-row">
        <p id="accountNum" class="account-name my-0">{{ account_details.account_number || 'NA' }} </p>
        <span @click.prevent="copyAccount('accountNum')">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.25 4.375V12.25H4.375V4.375H12.25ZM12.25 3.5H4.375C4.14294 3.5 3.92038 3.59219 3.75628 3.75628C3.59219 3.92038 3.5 4.14294 3.5 4.375V12.25C3.5 12.4821 3.59219 12.7046 3.75628 12.8687C3.92038 13.0328 4.14294 13.125 4.375 13.125H12.25C12.4821 13.125 12.7046 13.0328 12.8687 12.8687C13.0328 12.7046 13.125 12.4821 13.125 12.25V4.375C13.125 4.14294 13.0328 3.92038 12.8687 3.75628C12.7046 3.59219 12.4821 3.5 12.25 3.5V3.5Z"
              fill="#262424" />
            <path
              d="M1.75 7.875H0.875V1.75C0.875 1.51794 0.967187 1.29538 1.13128 1.13128C1.29538 0.967187 1.51794 0.875 1.75 0.875H7.875V1.75H1.75V7.875Z"
              fill="#262424" />
          </svg>
        </span>
      </div>
      <small v-if="account_details.sort_code" style="color: #777474;">
        <span id="accountName">{{ account_details.account_name }}</span> &nbsp;
        <span @click.prevent="copyAccount('accountName')">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.25 4.375V12.25H4.375V4.375H12.25ZM12.25 3.5H4.375C4.14294 3.5 3.92038 3.59219 3.75628 3.75628C3.59219 3.92038 3.5 4.14294 3.5 4.375V12.25C3.5 12.4821 3.59219 12.7046 3.75628 12.8687C3.92038 13.0328 4.14294 13.125 4.375 13.125H12.25C12.4821 13.125 12.7046 13.0328 12.8687 12.8687C13.0328 12.7046 13.125 12.4821 13.125 12.25V4.375C13.125 4.14294 13.0328 3.92038 12.8687 3.75628C12.7046 3.59219 12.4821 3.5 12.25 3.5V3.5Z"
              fill="#262424" />
            <path
              d="M1.75 7.875H0.875V1.75C0.875 1.51794 0.967187 1.29538 1.13128 1.13128C1.29538 0.967187 1.51794 0.875 1.75 0.875H7.875V1.75H1.75V7.875Z"
              fill="#262424" />
          </svg>
        </span>
      </small>

      <small class="mb-0" v-if="account_details.payment_reference">
        <br>
        PAYMENT REF: <strong><span id="paymentReference">{{ account_details.payment_reference }}</span></strong> &nbsp;
        <span @click.prevent="copyAccount('paymentReference')">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.25 4.375V12.25H4.375V4.375H12.25ZM12.25 3.5H4.375C4.14294 3.5 3.92038 3.59219 3.75628 3.75628C3.59219 3.92038 3.5 4.14294 3.5 4.375V12.25C3.5 12.4821 3.59219 12.7046 3.75628 12.8687C3.92038 13.0328 4.14294 13.125 4.375 13.125H12.25C12.4821 13.125 12.7046 13.0328 12.8687 12.8687C13.0328 12.7046 13.125 12.4821 13.125 12.25V4.375C13.125 4.14294 13.0328 3.92038 12.8687 3.75628C12.7046 3.59219 12.4821 3.5 12.25 3.5V3.5Z"
              fill="#262424" />
            <path
              d="M1.75 7.875H0.875V1.75C0.875 1.51794 0.967187 1.29538 1.13128 1.13128C1.29538 0.967187 1.51794 0.875 1.75 0.875H7.875V1.75H1.75V7.875Z"
              fill="#262424" />
          </svg>
        </span>
      </small>

      <br />
      <small v-if="copied" style="color: #777474;">Copied !</small>
    </div>
    <span class="hint" v-if="account_details.payment_reference">
      To complete your transaction, kindly transfer <strong>{{ account_details.currency || 'NGN' }} {{ account_details.amount }}</strong> to the account above and enter your PNR <strong>{{ account_details.payment_reference }}</strong> as the payment reference or narration to help us match your payment.
    </span>
    <span class="hint" v-else>
      To complete your transaction, kindly transfer <strong>{{ account_details.currency || 'NGN' }} {{
        account_details.amount }}</strong> to the account above.
    </span>

    <span class="hint">Once we confirm the transfer, you'd receive a notification and receipt by email.</span>

    <a href="javascript:void(0);return;" class="btn" @click.prevent="continueToMerchant"> Return to Merchant</a>

    <div v-if="account_details.js_upsell_notice" class="hint-footer">
      <svg width="50" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 0.875C3.61758 0.875 0.875 3.61758 0.875 7C0.875 10.3824 3.61758 13.125 7 13.125C10.3824 13.125 13.125 10.3824 13.125 7C13.125 3.61758 10.3824 0.875 7 0.875ZM7 12.0859C4.1918 12.0859 1.91406 9.8082 1.91406 7C1.91406 4.1918 4.1918 1.91406 7 1.91406C9.8082 1.91406 12.0859 4.1918 12.0859 7C12.0859 9.8082 9.8082 12.0859 7 12.0859Z"
          fill="#636363" />
        <path
          d="M6.34375 4.59375C6.34375 4.7678 6.41289 4.93472 6.53596 5.05779C6.65903 5.18086 6.82595 5.25 7 5.25C7.17405 5.25 7.34097 5.18086 7.46404 5.05779C7.58711 4.93472 7.65625 4.7678 7.65625 4.59375C7.65625 4.4197 7.58711 4.25278 7.46404 4.12971C7.34097 4.00664 7.17405 3.9375 7 3.9375C6.82595 3.9375 6.65903 4.00664 6.53596 4.12971C6.41289 4.25278 6.34375 4.4197 6.34375 4.59375ZM7.32812 6.125H6.67188C6.61172 6.125 6.5625 6.17422 6.5625 6.23438V9.95312C6.5625 10.0133 6.61172 10.0625 6.67188 10.0625H7.32812C7.38828 10.0625 7.4375 10.0133 7.4375 9.95312V6.23438C7.4375 6.17422 7.38828 6.125 7.32812 6.125Z"
          fill="#636363" />
      </svg>
      <span class="fade text-bold f-14" v-html="account_details.js_upsell_notice"></span>
    </div>

    <div class="col-12 px-0 mt-4 text-center">
      <a href="javascript:void(0)" class="change-option" @click.prevent="chooseAnotherMethod"> &larr; Choose
        another method </a>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'PWTAccountDetailsRhemito',
  props: {
    account_details: {
      type: Object,
      required: true,
    },
    client_info: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      copied: false,
    }
  },

  methods: {

    chooseAnotherMethod() {
      const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`;
      this.$store.dispatch('transRef', newRef);
      this.$store.dispatch('isFailed', true);
      this.$emit('changePaymentOption');
    },
    copyAccount(target) {
      if (window.navigator.clipboard) {
        try {
          let copyText = document.getElementById(target);
          window.navigator.clipboard.writeText(copyText.innerHTML.toString().trim());
          document.execCommand('Copy');
          this.copied = true;
          setTimeout(() => {
            this.copied = false;
          }, 4000)
        } catch (e) {
          console.log(e);
        }
      }
    },
    continueToMerchant() {
      this.$emit('continueToMerchant', {
        status: 'PendingFulfilment',
        message: 'Thank you! Receipt will be sent to your provided email once payment is confirmed.'
      });
    },
  },
}
</script>

<style scoped>
.f-14 {
  font-size: 14px
}

.modal-body p {
  text-align: center;
}

.modal-body p {
  font-size: 15px;
  line-height: 20px;
  color: #b1b1b1;
}

.modal-body p.amount {
  font-weight: bold;
  font-size: 30px;
  line-height: 41px;
  text-align: center;
  color: #000000;
}

.modal-body .details-price {
  margin-top: 30px;
  padding: 0 15px;
}

.modal-body .details-price .list-detail {
  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 1fr 1fr;
  grid-template-columns: 1fr 1fr;
  /*margin-bottom: 20px;*/
  font-size: 16px;
  text-align: left !important;
}

.modal-body .details-price .list-detail .title {
  text-align: left !important;
}

.modal-body .details-price .list-detail .strong {
  color: #000000;
  -ms-grid-column-align: self-end;
  justify-self: self-end;
  text-align: right;
}

.modal-body .details-account {
  background: #e2f8ff;
  border-radius: 5px;
  padding: 20px 0;
  text-align: center;
}

.modal-body .details-account p {
  color: #393939;
}

.modal-body .details-account .account-name {
  font-weight: bold;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  text-transform: capitalize;
  color: #000000;
  margin-top: 10px;
}

.modal-body span.hint {
  text-align: center;
  display: block;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  /* display: -webkit-box;
        display: -ms-flexbox;
        display: flex; */
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
  color: #2a3b44;
  width: 85%;
  margin: 15px auto;
}

@media screen and (max-width: 500px) {
  .modal-body span.hint {
    width: 90%;
  }
}

.modal-body a.btn {
  background: #ffffff;
  border: 1px solid #1f3946;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 2px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: rgba(31, 57, 70, 0.92);
  padding: 15px 0;
}

.modal-body a.btn:hover {
  opacity: 0.8;
}

.hint-footer {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  text-align: center;
  color: #545454;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 15px auto;
  width: 85%;
}

.copy-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.copy-row svg {
  margin-left: 5px;
  margin-top: 13px;

  cursor: pointer;
}
</style>
